import { Injectable } from "@angular/core";
import { B2bCatalogService } from "b2b-ecommerce-lib";

@Injectable({
  providedIn: "root",
})
export class CatalogService extends B2bCatalogService {}
